import {GetterTree} from 'vuex';
import {WidgetState} from '@/modules/widget/store/index';
import {RootState} from '@/store/types';

const getters: GetterTree<WidgetState, RootState> = {
    /**
     * Busca un widget por id
     *
     * @param state
     */
    widget: (state) => (id: number) => state.layout.find(w => w.id === id) || null,

    /**
     * Busca un tipo de widget por su nombre
     *
     * @param state
     */
    widgetType: (state) => (name: string) => state.widgetTypes.find(wt => wt.name === name) || null,
}

export default getters

